import React from "react"
import TeamMembersHeader from "./controllers/teamMembersHeader.controller"
import TeamMembersTable from "./controllers/teamMembersTable.controller"

const TeamMembers = () => {
  return (
    <>
      <TeamMembersHeader />
      <TeamMembersTable />
    </>
  )
}

export default TeamMembers
